const values = {
  CUSTOM: 'custom',
  TODAY: 'today',
  YESTERDAY: 'yesterday',
  LAST_WEEK: 'last week',
  LAST_MONTH: 'last month',
  LAST_7_DAYS: 'last 7 days',
  LAST_30_DAYS: 'last 30 days',
  PREVIOUS_PERIOD: 'previousPeriod',
  PREVIOUS_YEAR: 'previousYear',
  NONE: 'none'
};

export default values;
